import advertisementPdf from "../../../assets/updates_pdf/Advertisementpdf.pdf";
import RecruitmentAdvertisement from "../../../assets/updates_pdf/RecruitmentAdvertisement.pdf";
import seniorLegalAdvisorApplicationPdf from "../../../assets/updates_pdf/RecruitentApplication.pdf";
const careerPdfContext = require.context(
  "../../../assets/career_pdf",
  false,
  /\.pdf$/,
);

const careerPdfFiles = careerPdfContext.keys().map((key) => ({
  fileName: key.replace("./", ""),
  href: careerPdfContext(key),
}));

const getCareerPdf = (matchers) =>
  careerPdfFiles.find(({ fileName }) =>
    matchers.some((matcher) => matcher.test(fileName)),
  ) || { fileName: "", href: "" };

const opportunityDetails = [
  {
    opportunity:
      "Company Secretary cum Chief Manager (Corporate Services) [IDA - E-3: ₹60,000-1,80,000]",
    publishDate: "25 Aug,2026",
    lastDate: "23 Sep,2026",
    pdf: {
      fileName: "Advertisementpdf.pdf",
      href: advertisementPdf,
    },
    applyUrl: "https://ibpsreg.ibps.in/nmdfcjul26/",
  },
    {
    opportunity:
      "Engagement as Senior Legal Advisor on a contractual basis",
    publishDate: "25 Aug,2026",
    lastDate: "09 Sep,2026",
    pdf: {
      fileName: "RecruitmentAdvertisement.pdf",
      href: RecruitmentAdvertisement,
    },
    applicationDocument: {
      title: "Application Form for Engagement as Senior Legal Advisor on a Contractual Basis",
      fileName: "RecruitentApplication.pdf",
      href: seniorLegalAdvisorApplicationPdf,
    },
  },

  {
    opportunity: "Engagement of Young Professionals (YPs)",
    publishDate: "16 Oct, 2025",
    lastDate: "27 Oct, 2025 04:00 PM",
    matchers: [/YPpdf/i, /young/i],
  },
  {
    opportunity: "Hiring of Consultant (Marketing & Finance)",
    publishDate: "19 Sep, 2025 06:30 PM",
    lastDate: "07 Oct, 2025 10:00 AM",
    matchers: [/consultant[-_]?MFpdf/i, /consultant/i],
  },
];

export const availableOpportunities = opportunityDetails.map(
  (opportunity, index) => {
    const pdf = opportunity.pdf || getCareerPdf(opportunity.matchers);

    return {
      serial: index + 1,
      opportunity: opportunity.opportunity,
      publishDate: opportunity.publishDate,
      lastDate: opportunity.lastDate,
      title: opportunity.opportunity,
      fileName: pdf.fileName,
      href: pdf.href,
      applyUrl: opportunity.applyUrl || "",
      applicationDocument: opportunity.applicationDocument || null,
    };
  },
);

const updateDetails = [
  {
    title:
      "New: List of shortlisted candidates for Interview for the post of Deputy Manager (E-1)- Company Secretary",
    matchers: [/CSpdf/i],
  },
  {
    title:
      "New: List of shortlisted candidates for Interview for the post of Assistant Manager (E-0) - Finance / Accounts",
    matchers: [/AMFAcctpdf/i],
  },
  {
    title:
      "New: List of shortlisted candidates for Interview for the post of Assistant Manager (E-0) - Projects / Coordination / Legal & Recovery",
    matchers: [/AMProjectCoordpdf/i],
  },
  {
    title:
      "New: List of shortlisted candidates for Interview for the post of Assistant Manager (E-0) - H&A",
    matchers: [/AMHRMpdf/i],
  },
  {
    title: "New: Executive Assistant Test Results (Held on 28.09.2025)",
    matchers: [/EA-Resultpdf/i],
  },
  {
    title: "New: Results of Direct Recruitment Examination Held on 28.09.2025",
    matchers: [/UpdatedResultDeclarationofExam/i],
  },
  {
    title:
      "New: Final Result of Assistant Managers (Direct Recruitment Examination Held on 28.09.2025)",
    matchers: [/AM-Result-pdf/i],
  },
];

const marksDetails = [
  {
    title:
      "Executive Assistant (General Stream): Number of candidates appeared in the written examination - 402",
    matchers: [/Test-resultscorepdf/i],
  },
  {
    title:
      "Assistant Manager (Project/Coordination/ Legal & Recovery): Number of candidates qualified in the written examination and appeared for interview - 07",
    matchers: [/AM-PLRpdf/i],
  },
  {
    title:
      "Assistant Manager (HRM & Administration): 03 Number of candidates qualified in the written examination and appeared for interview",
    matchers: [/AM-HRMpdf/i],
  },
  {
    title:
      "Assistant Manager (Finance & Accounts): 02 Number of candidates qualified in the written examination and appeared for interview",
    matchers: [/AM-Finpdf/i],
  },
];

const attachCareerPdf = (document, index) => {
  const pdf = getCareerPdf(document.matchers);

  return {
    serial: index + 1,
    title: document.title,
    fileName: pdf.fileName,
    href: pdf.href,
  };
};

export const careerUpdates = updateDetails.map(attachCareerPdf);
export const careerMarksUpdates = marksDetails.map(attachCareerPdf);

const internshipPdf = getCareerPdf([/NMDFCInternshipSchemePDF/i]);

export const internshipSchemeDocument = {
  serial: 1,
  title: "Internship Scheme",
  fileName: internshipPdf.fileName,
  href: internshipPdf.href,
};
